import MemberLayoutMain from "../components/memberLayout";
import ModuleEmptyPage from "../components/emptyPage";

import MemberMain from "../page/member";
import MemberRecord from "../page/member/record";
import MemberRecordHeartbeat from "../page/member/record/heartbeat";
import MemberRecordWeight from "../page/member/record/weight";
import MemberRecordSugar from "../page/member/record/sugar";
import MemberRecordUncomfortable from "../page/member/record/uncomfortable";
import MemberRecordHealth from "../page/member/record/health";
import MemberSetting from "../page/member/setting";
import MemberSettingProfile from "../page/member/setting/profile";
import MemberSettingDangerous from "../page/member/setting/dangerous";
import MemberSettingTarget from "../page/member/setting/target";
import MemberSettingPrivacy from "../page/member/setting/privacy";
import MemberSettingSecurity from "../page/member/setting/security";
import MemberSettingManual from "../page/member/setting/manual";
import MemberQaMain from "../page/member/qa";
import MemberKnowledge from "../page/member/knowledge";
import MemberKnowledgeType from "../page/member/knowledge/type";
import MemberWork from "../page/member/work";

const routes = [
  {
    path: "member",
    element: <MemberLayoutMain />,
    children: [
      {
        path: "",
        element: <MemberMain />,
      },

      {
        path: "record",
        element: <MemberRecord />,
      },
      {
        path: "record/heartbeat",
        element: <MemberRecordHeartbeat />,
      },
      {
        path: "record/weight",
        element: <MemberRecordWeight />,
      },
      {
        path: "record/sugar",
        element: <MemberRecordSugar />,
      },
      {
        path: "record/uncomfortable",
        element: <MemberRecordUncomfortable />,
      },
      {
        path: "record/health",
        element: <MemberRecordHealth />,
      },

      {
        path: "setting",
        element: <MemberSetting />,
      },
      {
        path: "setting/profile",
        element: <MemberSettingProfile />,
      },
      {
        path: "setting/dangerous",
        element: <MemberSettingDangerous />,
      },
      {
        path: "setting/work",
        element: <MemberSettingTarget />,
      },
      {
        path: "setting/privacy",
        element: <MemberSettingPrivacy />,
      },
      {
        path: "setting/security",
        element: <MemberSettingSecurity />,
      },
      {
        path: "setting/manual",
        element: <MemberSettingManual />,
      },

      {
        path: "qa",
        element: <MemberQaMain />,
      },

      {
        path: "knowledge",
        element: <MemberKnowledge />,
      },
      {
        path: "knowledge/:type",
        element: <MemberKnowledgeType />,
      },

      {
        path: "work",
        element: <MemberWork />,
      },

      {
        path: "*",
        element: <ModuleEmptyPage />,
      },
    ],
  },
];

export default {
  routes,
};
